<template>
    <div class="page-container">
        <!-- 导航栏 -->
        <div class="nav-bar">
            <div class="nav-back" @click="goBack">
                <span class="back-arrow">‹</span>
                <span class="back-text">返回</span>
            </div>
            <span class="nav-title">我的订单</span>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 标签栏 -->
        <div class="tab-bar">
            <div
                    class="tab-item"
                    :class="{ active: currentTab === 0 }"
                    @click="onTabChange(0)"
            >
                <span>全部</span>
            </div>
            <div
                    class="tab-item"
                    :class="{ active: currentTab === 1 }"
                    @click="onTabChange(1)"
            >
                <span>待接单</span>
                <span class="tab-count" v-if="pendingCount > 0">·{{ pendingCount }}</span>
            </div>
            <div
                    class="tab-item"
                    :class="{ active: currentTab === 2 }"
                    @click="onTabChange(2)"
            >
                <span>进行中</span>
            </div>
            <div
                    class="tab-item"
                    :class="{ active: currentTab === 3 }"
                    @click="onTabChange(3)"
            >
                <span>已完成</span>
            </div>
        </div>

        <!-- 订单列表 -->
        <div class="order-list" style="overflow-y: auto;">
            <div
                    class="order-card"
                    v-for="item in filteredOrders"
                    :key="item.id"
            >
                <!-- 顶部：日期 + 支付状态 -->
                <div class="card-top">
                    <div class="date-info">
                        <span class="date-icon">📅</span>
                        <span class="date-text">更新日期：{{ item.updateTime }}</span>
                    </div>
                    <span class="pay-status" :class="item.statusTextClass">{{ item.statusText }}</span>
                </div>

                <!-- 服务状态行 -->
                <div class="card-status">
                    <div class="status-tag" :class="item.statusTagClass">{{ item.statusTagName }}</div>
                    <span class="service-type">{{ item.planName }}</span>
                    <span class="service-days">{{ item.serviceDays }}天</span>
                    <div class="amount-info">
                        <!-- <div class="amount-row" v-if="item.status == 100">
                            <span class="amount-label">结算金额</span>
                            <span class="amount-value">¥{{ item.totalAmount }}</span>
                        </div> -->
                         <div class="amount-row">
                            <span class="amount-label">订单金额</span>
                            <span class="amount-value">¥{{ item.orderAmounts.orderAmount }}</span>
                        </div>
                        <div class="amount-row">
                            <span class="amount-label paid">已缴金额</span>
                            <span class="amount-value paid">¥{{ item.orderAmounts.receivedAmount }}</span>
                        </div>
                          <div class="amount-row" v-if="item.orderAmounts.refundAmount">
                            <span class="amount-label refund">已退金额</span>
                            <span class="amount-value refund">¥{{ item.orderAmounts.refundAmount }}</span>
                        </div>
                    </div>
                </div>

                <!-- 患者信息 -->
                <div class="card-info">
                    <div class="info-row">
                        <span class="info-label">被照护人：</span>
                        <span class="info-value">{{ item.patientName }}</span>
                        <div class="info-tag" v-if="item.patientAge">{{ item.patientAge }}岁</div>
                        <div class="info-tag" v-if="item.patientGender">{{ item.patientGender }}</div>
                    </div>
                    <div class="info-row">
                        <span class="info-label">服务地点：</span>
                        <span class="info-value">{{ item.divisionBed }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">账单号：</span>
                        <span class="info-value">{{ item.orderNo }}</span>
                    </div>
                    <div class="info-row row-bottom">
                        <div class="info-left">
                            <span class="info-label">服务开始时间：</span>
                            <span class="info-value">{{ item.startTime }}</span>
                        </div>
                        <button
                                class="action-btn"
                                :class="item.btnClass"
                                @click="onOrderAction(item)"
                        >
                            {{ item.btnText }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div class="empty-state" v-if="filteredOrders.length === 0">
                <span class="empty-text">暂无订单</span>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'order',
        data() {
            return {
                currentTab: 0,
                orders: [],
                filteredOrders: [],
                pendingCount: 0,
                showQRModal: false,
                qrImageUrl: '',
                payStatus: -1,
                _currentOrder: null,
                _orderCenterId: '',
                _payPollTimer: null
            }
        },
        mounted() {
            const tab = this.$route.query.tab
            if (tab !== undefined && !isNaN(tab)) {
                this.currentTab = parseInt(tab)
            }
            this.fetchOrderList()
        },
        methods: {
            goBack() {
                this.$router.back()
            },

            /**
             * 获取订单列表
             */
            async fetchOrderList() {
                try {
                    let url = "/api-enterprise/caregiver/order/list"
                    let query = {}
                    this.$api.post(url, query, response => {
                        if (response.data.result == "success") {
                            let datas = response.data.data || []
                            datas = datas.map(item => {
                                if (item.status === -1) {
                                    item.status = 99
                                }
                                return item
                            })
                            const orders = datas.map(order => this.formatOrder(order))
                            const pendingCount = orders.filter(o => o.status === 0).length

                            this.orders = orders
                            this.pendingCount = pendingCount
                            this.filterOrders()
                        }
                    })

                } catch (err) {
                    this.$toast ? this.$toast('获取订单列表失败') : alert('获取订单列表失败')
                    console.error('fetchOrderList fail:', err)
                }
            },

            /**
             * 格式化订单数据
             */
            formatOrder(order) {
                const statusMap = {
                    0: {
                        statusTagName: '待接单',
                        statusTagClass: 'pending',
                        btnText: '查看详情',
                        btnClass: 'detail'
                    },
                    1: {
                        statusTagName: '已完成',
                        statusTagClass: 'completed',
                        btnText: '查看详情',
                        btnClass: 'detail'
                    },
                    2: {
                        statusTagName: '服务中',
                        statusTagClass: 'in-progress',
                        btnText: '查看详情',
                        btnClass: 'detail'
                    },
                    99: {
                        statusText: '已取消',
                        statusTextClass: 'completed',
                        statusTagName: '已取消',
                        statusTagClass: 'completed',
                        btnText: '查看详情',
                        btnClass: 'detail'
                    },
                    100: {
                        statusTagName: '已结算',
                        statusTagClass: 'completed',
                        btnText: '查看详情',
                        btnClass: 'detail'
                    }
                }

                let statusInfo = statusMap[order.status] || statusMap[0]

                if (order.status === 99) {
                    statusInfo = {
                        ...statusInfo,
                        statusText: '已取消',
                        statusTextClass: 'completed',
                    }
                } else if (order.isPaid) {
                    statusInfo = {
                        ...statusInfo,
                        statusText: '已支付',
                        statusTextClass: 'completed',
                    }
                } else if (order.isWait) {
                    statusInfo = {
                        ...statusInfo,
                        statusText: '等待支付结果',
                        statusTextClass: 'unpaid',
                    }
                } else if ((order.isPaid === undefined && order.isWait === undefined)&&(order.status == 0 || order.status == 2)) {
                    statusInfo = {
                        ...statusInfo,
                        statusText: '待支付',
                        statusTextClass: 'unpaid',
                        btnText: '去缴费',
                        btnClass: 'pay'
                    }
                }
                      
                if(order.status == 100){
                    if(order.settleAmount > order.paidAmount){
                        statusInfo = {
                            ...statusInfo,
                            statusText: '待支付',
                            statusTextClass: 'unpaid',
                        }
                    } else if(order.settleAmount == order.paidAmount){
                        statusInfo = {
                            ...statusInfo,
                            statusText: '已支付',
                            statusTextClass: 'completed',
                        }
                    } else if(order.settleAmount < order.paidAmount){
                        statusInfo = {
                            ...statusInfo,
                            statusText: '待退费',
                            statusTextClass: 'unpaid',
                        }
                    }
                }

                return {
                    ...order,
                    ...statusInfo,
                    updateTime: order.updateTime || order.createTime,
                    totalAmount: (order.orderAmounts.orderAmount || order.paymentAmount || order.amount || 0).toFixed(2),
                    paidAmount: (order.paidAmount || 0).toFixed(2),
                    patientName: order.patientName || '--',
                    patientAge: order.patientAge || '',
                    patientGender: order.patientGender || '',
                    orderNo: order.orderNo || '--',
                    startTime: order.startTime || '--',
                    divisionBed: order.bedNumber
                        ? (order.divisionName + order.bedNumberCn)
                        : order.divisionName || '--',
                    planName: order.caregiverPlan ? order.caregiverPlan.name : '陪护服务'
                }
            },

            /**
             * 切换Tab
             */
            onTabChange(tab) {
                this.currentTab = tab
                this.filterOrders()
            },

            /**
             * 过滤订单
             */
            filterOrders() {
                let filtered = this.orders
                if (this.currentTab === 1) {
                    filtered = this.orders.filter(o => o.status === 0)
                } else if (this.currentTab === 2) {
                    filtered = this.orders.filter(o => o.status === 2)
                } else if (this.currentTab === 3) {
                    filtered = this.orders.filter(o => o.status === 1 || o.status === 100)
                } 
                this.filteredOrders = filtered
            },

            /**
             * 订单操作按钮
             */
            onOrderAction(order) {
                if (order.status === 0) {
                    if(order.isPaid === undefined && order.isWait === undefined){
                        this.$router.push({
                            path: '/orderDetail',
                            query: { orderId: order.id }
                        })
                    }else{
                        this.$router.push({
                            path: '/orderDetailProgress',
                            query: { orderId: order.id }
                        })
                    }
                  
                } else if (order.status === 99) {
                    this.$router.push({
                        path: '/orderDetail',
                        query: { orderId: order.id }
                    })
                } else {
                    this.$router.push({
                        path: '/orderDetailProgress',
                        query: { orderId: order.id }
                    })
                }
            },
        }
    }
</script>

<style scoped>
.page-container {
    min-height: 100vh;
    background-color: #f5f7fa;
}

/* 导航栏 */
.nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    padding: 0 15px;
    background-color: #fff;
    border-bottom: 1px solid #eee;
}

.nav-back {
    display: flex;
    align-items: center;
    gap: 2.5px;
    cursor: pointer;
}

.back-arrow { font-size: 16px; color: #07c160; }
.back-text { font-size: 14px; color: #07c160; }
.nav-title { font-size: 16px; font-weight: 600; color: #333; }
.nav-placeholder { width: 50px; }

/* 标签栏 */
.tab-bar {
    display: flex;
    background-color: #fff;
    border-bottom: 1px solid #eee;
}

.tab-item {
    flex: 1;
    padding: 12.5px;
    text-align: center;
    font-size: 14px;
    color: #999;
    position: relative;
}

.tab-item.active {
    color: #333;
    font-weight: 600;
}

.tab-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 2px;
    background-color: #07c160;
    border-radius: 1px;
}

.tab-count { color: #07c160; }

/* 订单列表 */
.order-list {
    height: calc(100vh - 44px - 40px);
}

.order-card {
    background-color: #fff;
    margin: 0 0 10px;
    padding: 12.5px 15px;
    border-bottom: 1px solid #f0f0f0;
}

/* 顶部：日期 + 支付状态 */
.card-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 7.5px;
}

.date-info {
    display: flex;
    align-items: center;
    gap: 4px;
}

.date-icon { font-size: 14px; }
.date-text { font-size: 12px; color: #666; }

.pay-status { font-size: 13px; font-weight: 600; }
.pay-status.unpaid { color: #ff3b30; }
.pay-status.completed { color: #999; }
.pay-status.normal { color: #666; }

/* 服务状态行 */
.card-status {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 7.5px;
}

.status-tag {
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 3px;
    color: #fff;
}

.status-tag.pending { background-color: #07c160; }
.status-tag.in-progress { background-color: #07c160; }
.status-tag.completed { background-color: #ccc; }

.service-type { font-size: 13px; color: #333; }
.service-days { font-size: 12px; color: #999; }

.amount-info {
    margin-left: auto;
    text-align: right;
}

.amount-row {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.amount-label {
    font-size: 12px;
    color: #999;
}

.amount-value {
    font-size: 13px;
    color: #333;
    font-weight: 600;
}

.amount-label.paid,
.amount-value.paid {
    color: #07c160;
}

.amount-label.refund,
.amount-value.refund {
    color: #ff3b30;
}



/* 患者信息 */
.card-info {
    border-top: 1px solid #f0f0f0;
    padding-top: 10px;
}

.info-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 5px;
}

.info-row.row-bottom {
    justify-content: space-between;
    margin-top: 8px;
}

.info-label {
    font-size: 12px;
    color: #999;
}

.info-value {
    font-size: 12px;
    color: #333;
}

.info-tag {
    background-color: #f0f0f0;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 11px;
    color: #666;
    margin-left: 6px;
}

.info-left {
    display: flex;
    align-items: center;
}

.action-btn {
    border: none;
    padding: 5px 12px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
}

.action-btn.pay {
    background-color: #07c160;
    color: #fff;
}

.action-btn.review {
    background-color: #ff9500;
    color: #fff;
}

.action-btn.detail {
    background-color: #f0f0f0;
    color: #666;
}

/* 空状态 */
.empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
}

.empty-text {
    font-size: 14px;
    color: #999;
}
</style>